import { msg } from "@lingui/core/macro";

/**
 * Messages reused across multiple files. Sharing one descriptor keeps the
 * wording (and thus the catalog entry and its translations) from diverging.
 */
export const genericErrorMsg = msg`An error occurred. Please try again later.`;
